import { render, staticRenderFns } from "./expressChangeReceive.vue?vue&type=template&id=a06dc42c&scoped=true"
import script from "./expressChangeReceive.vue?vue&type=script&lang=js"
export * from "./expressChangeReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06dc42c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a06dc42c')) {
      api.createRecord('a06dc42c', component.options)
    } else {
      api.reload('a06dc42c', component.options)
    }
    module.hot.accept("./expressChangeReceive.vue?vue&type=template&id=a06dc42c&scoped=true", function () {
      api.rerender('a06dc42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/expressOrderList/components/expressChangeReceive.vue"
export default component.exports